@if (!is_mobile) {
  <h4 class="mb-3 border-bottom display-4 filter-category">
    {{ 'shop' | translate }}
  </h4>
  <ts-asset-category-filter [categories]="categories"></ts-asset-category-filter>
}

<ng-container>
  @if (!is_mobile && has_filters) {
    <h4 class="pt-3 mb-3 border-bottom display-4 filter-category">
      {{ 'filters' | translate }}
    </h4>
  }
  <ts-filters [filters]="filters" [is_mobile]="is_mobile"></ts-filters>
</ng-container>
